export default function PinIcon() {
    return null;
}
//# sourceMappingURL=PinIcon.js.map